"use client";

import { c as _c } from "react/compiler-runtime";
import CircularProgress from "@mui/material/CircularProgress";
import ComponentLoading from "@/components/global/component-loading";
import useIsMobile from "@/hooks/use-mobile";
import { useClubsInfiniteQuery } from "@/hooks/useClubsInfiniteQuery";
import { useInfiniteScroll } from "@/hooks/useInfiniteScroll";
import { useClubsFiltersStore } from "@/stores/clubs-filters-store";
import { Club } from "@/TS/Interfaces/global_interfaces";
import ClubCard from "./ClubCard";
import CreateClubCard from "./CreateClubCard";
export default function ClubsList() {
  const $ = _c(41);
  const isMobile = useIsMobile();
  const themes = useClubsFiltersStore(_temp);
  const format = useClubsFiltersStore(_temp2);
  const location = useClubsFiltersStore(_temp3);
  const t0 = location.address || location.zipCode || location.city ? location : undefined;
  let t1;
  if ($[0] !== format || $[1] !== t0 || $[2] !== themes) {
    t1 = {
      pageSize: 24,
      staleTime: 300000,
      theme: themes,
      format,
      location: t0
    };
    $[0] = format;
    $[1] = t0;
    $[2] = themes;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
    error,
    data
  } = useClubsInfiniteQuery(t1);
  const t2 = !!hasNextPage;
  let t3;
  if ($[4] !== fetchNextPage || $[5] !== isFetchingNextPage || $[6] !== t2) {
    t3 = {
      hasNextPage: t2,
      isFetchingNextPage,
      fetchNextPage
    };
    $[4] = fetchNextPage;
    $[5] = isFetchingNextPage;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    loadMoreRef
  } = useInfiniteScroll(t3);
  if (isLoading) {
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="h-[350px] w-full flex items-center justify-center"><ComponentLoading /></div>;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  if (isError) {
    console.error("Erreur dans useInfiniteQuery:", error);
    const t4 = error?.message || "Erreur inconnue";
    let t5;
    if ($[9] !== t4) {
      t5 = <div className="text-primary mt-4">Erreur lors du chargement des clubs:{" "}{t4}</div>;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let allClubs;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[11] !== data?.pages || $[12] !== isMobile) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      allClubs = data?.pages.flatMap(_temp4) || [];
      const totalItems = data?.pages[0]?.totalItems || 0;
      if (allClubs.length === 0) {
        let t10;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = <div className="text-gray-500">Aucun club trouvé</div>;
          $[20] = t10;
        } else {
          t10 = $[20];
        }
        t9 = t10;
        break bb0;
      }
      t7 = "space-y-4";
      t8 = <div className={`text-xl text-gray-500 pt-4 font-bold ${isMobile ? "text-center pb-0" : "pb-4"}`}>{allClubs.length} clubs affichés sur {totalItems}</div>;
      t6 = "grow";
      t4 = `flex flex-wrap ${isMobile ? "justify-center gap-4" : "justify-evenly"}`;
      t5 = allClubs.map(_temp5);
    }
    $[11] = data?.pages;
    $[12] = isMobile;
    $[13] = allClubs;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    allClubs = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[21] !== allClubs || $[22] !== hasNextPage) {
    t10 = !hasNextPage && allClubs.length > 0 && <CreateClubCard />;
    $[21] = allClubs;
    $[22] = hasNextPage;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t4 || $[26] !== t5) {
    t11 = <div className={t4}>{t5}{t10}</div>;
    $[24] = t10;
    $[25] = t4;
    $[26] = t5;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t6) {
    t12 = <div className={t6}>{t11}</div>;
    $[28] = t11;
    $[29] = t6;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== isFetchingNextPage) {
    t13 = isFetchingNextPage && <div className="text-primary flex items-center gap-3"><CircularProgress sx={{
        color: "#EE4540"
      }} /></div>;
    $[31] = isFetchingNextPage;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== loadMoreRef || $[34] !== t13) {
    t14 = <div ref={loadMoreRef} className="h-10 flex items-center justify-center">{t13}</div>;
    $[33] = loadMoreRef;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t12 || $[37] !== t14 || $[38] !== t7 || $[39] !== t8) {
    t15 = <div className={t7}>{t8}{t12}{t14}</div>;
    $[36] = t12;
    $[37] = t14;
    $[38] = t7;
    $[39] = t8;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
}
function _temp5(club, index) {
  return <ClubCard key={club.id || club.name || index} club={club} />;
}
function _temp4(page) {
  return page.clubs;
}
function _temp3(state_1) {
  return state_1.location;
}
function _temp2(state_0) {
  return state_0.format;
}
function _temp(state) {
  return state.theme;
}